export function dedupeFolders(folders) {
  const uniqFolders = {}
  folders.forEach(folder => {
    const key = `${folder.name}${folder.default}${
      folder.matchType
    }${folder.conditions.map(c => c.param).join('')}`
    if (!uniqFolders[key]) {
      uniqFolders[key] = folder
    }
  })
  return Object.values(uniqFolders)
}
